<div
  class="ccl-badge ccl-badge--{{ variant }} ccl-badge--{{ size }} ccl-badge--{{ shape }}"
  [class.ccl-badge--clickable]="clickable"
  [class.ccl-badge--dismissible]="dismissible"
  [class.ccl-badge--disabled]="disabled"
  [class.ccl-badge--count]="count !== null"
  [attr.role]="role"
  [attr.aria-label]="ariaLabel"
  [attr.tabindex]="tabIndex"
  [style.background-color]="variant === 'custom' ? customColor : null"
  [style.color]="variant === 'custom' ? 'white' : null"
  (click)="onBadgeClick()"
  (keydown)="onKeydown($event)"
>
  <!-- Leading Icon -->
  @if (icon && count === null) {
    <span class="ccl-badge__icon ccl-badge__icon--leading" aria-hidden="true">
      {{ icon }}
    </span>
  }

  <!-- Badge Content -->
  <span class="ccl-badge__content">
    {{ displayText }}
  </span>

  <!-- Dismiss Button -->
  @if (dismissible) {
    <button
      type="button"
      class="ccl-badge__dismiss"
      aria-label="Remove {{ label || 'badge' }}"
      (click)="onDismissClick($event)"
      (keydown)="onDismissKeydown($event)"
    >
      <span aria-hidden="true">×</span>
    </button>
  }
</div>










